import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, PHOTOGRAPHER_AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { ROLE_IDS } from 'constants/RolesConstats';

const PublicRoute = () => {
	const { token, singleUser } = useSelector(state => state.auth);

	const getRedirectPath = () => {
		if (!token) return null;

		switch (singleUser?.role?.position_id) {
			case ROLE_IDS.PHOTOGRAPHER:
				return PHOTOGRAPHER_AUTHENTICATED_ENTRY;
			default:
				return AUTHENTICATED_ENTRY;
		}
	};

	const redirectPath = getRedirectPath();

	return redirectPath ? <Navigate to={redirectPath} /> : <Outlet />;
};

export default PublicRoute;